/* ArmorThane · Blog interactions: reading progress, chapter tracking, mobile chapter pill,
   copy link, responsive tables, sticky offsets, hero blog-rail tabs */
(function(){
  var d=document,W=window,root=d.documentElement;
  function $(s,c){return (c||d).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}

  /* ---- hero blog rail tabs (home page) ---- */
  $$('[data-brail]').forEach(function(r){
    var tabs=$$('[role=tab]',r);
    function sel(t,focus){
      tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;
        var p=d.getElementById(x.getAttribute('aria-controls'));if(p){p.hidden=!on;if(on){p.classList.remove('is-in');void p.offsetWidth;p.classList.add('is-in')}}});
      r.style.setProperty('--ti',tabs.indexOf(t));
      if(focus)t.focus();
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){sel(t)});
      t.addEventListener('keydown',function(e){var k=e.key,n=null;
        if(k==='ArrowRight')n=tabs[(i+1)%tabs.length];else if(k==='ArrowLeft')n=tabs[(i-1+tabs.length)%tabs.length];
        if(n){e.preventDefault();sel(n,true)}});
    });
  });

  /* ---- header offset for sticky elements ---- */
  function hdrBottom(){var h=$('.at-hroot')||$('#header-group')||$('header');if(!h)return 0;var b=h.getBoundingClientRect().bottom;return b>0?Math.round(b):0}
  var cats=$('.atb-cats');

  /* ---- copy link ---- */
  $$('[data-copy]').forEach(function(b){b.addEventListener('click',function(){
    var u=b.getAttribute('data-copy');
    function done(){b.classList.add('is-copied');setTimeout(function(){b.classList.remove('is-copied')},1800)}
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(u).then(done,done)}else{var t=d.createElement('textarea');t.value=u;d.body.appendChild(t);t.select();try{d.execCommand('copy')}catch(e){}t.remove();done()}
  })});

  var prose=$('.ata-prose');
  /* ---- responsive tables ---- */
  if(prose)$$('table',prose).forEach(function(t){if(t.parentNode.classList.contains('ata-tbl'))return;var w=d.createElement('div');w.className='ata-tbl';w.tabIndex=0;w.setAttribute('role','region');w.setAttribute('aria-label','Table');t.parentNode.insertBefore(w,t);w.appendChild(t)});

  var art=$('.ata');
  var bar=$('.ata-progress span');
  var tocLinks=$$('.ata-toc__list a[data-toc]');
  var ids=[];tocLinks.forEach(function(a){var id=a.getAttribute('data-toc');if(ids.indexOf(id)<0)ids.push(id)});
  var heads=ids.map(function(id){return d.getElementById(id)}).filter(Boolean);
  var tocBar=$('.ata-toc__bar span');
  var chap=$('[data-chap]'),chapN=chap&&$('[data-chap-n]',chap),chapT=chap&&$('[data-chap-t]',chap),chapBtn=chap&&$('.ata-chap__btn',chap);
  var main=$('.ata-main');
  var cur=-1,ticking=false;

  if(chap){
    chap.hidden=false;
    chapBtn.addEventListener('click',function(){var o=!chap.classList.contains('is-open');chap.classList.toggle('is-open',o);chapBtn.setAttribute('aria-expanded',o?'true':'false')});
    $$('a',chap).forEach(function(a){a.addEventListener('click',function(){chap.classList.remove('is-open');chapBtn.setAttribute('aria-expanded','false')})});
    d.addEventListener('click',function(e){if(!chap.contains(e.target)){chap.classList.remove('is-open');chapBtn.setAttribute('aria-expanded','false')}});
  }

  function update(){
    ticking=false;
    var hb=hdrBottom();
    if(cats)cats.style.setProperty('--atb-top',hb+'px');
    if(art)art.style.setProperty('--ata-top',(Math.max(hb,0)+20)+'px');
    if(!main)return;
    var r=main.getBoundingClientRect(),vh=W.innerHeight;
    var total=r.height-vh*.6,done=Math.min(1,Math.max(0,(-r.top+vh*.25)/Math.max(1,total)));
    if(bar)bar.parentNode.style.setProperty('--p',done.toFixed(4));
    if(tocBar)tocBar.parentNode.style.setProperty('--p',done.toFixed(4));
    if(chap){chap.style.setProperty('--p',done.toFixed(4));chap.classList.toggle('is-in',r.top<vh*.35&&r.bottom>vh*.5)}
    var line=hb+vh*.22,idx=-1;
    for(var i=0;i<heads.length;i++){if(heads[i].getBoundingClientRect().top<=line)idx=i;else break}
    if(idx<0&&heads.length)idx=0;
    if(idx!==cur){cur=idx;var id=heads[idx]&&heads[idx].id;
      tocLinks.forEach(function(a){var k=ids.indexOf(a.getAttribute('data-toc'));a.classList.toggle('is-on',k===idx);a.classList.toggle('is-done',k<idx);if(k===idx)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current')});
      if(chap&&id){chapN.textContent=idx+1;var a=$('a[data-toc="'+id+'"] .t',chap);chapT.textContent=a?a.textContent:''}
      var side=$('.ata-toc .ata-toc__list a.is-on');if(side){var l=side.closest('.ata-toc__list');var o=side.offsetTop-l.clientHeight/2;if(Math.abs(l.scrollTop-o)>40)l.scrollTop=o}
    }
  }
  function onS(){if(!ticking){ticking=true;W.requestAnimationFrame(update)}}
  if(cats||art){W.addEventListener('scroll',onS,{passive:true});W.addEventListener('resize',onS);update()}
  if(chap){chap.parentNode.removeChild(chap);d.body.appendChild(chap)}
})();
